import React from "react";
import { bool, node, shape, string } from "prop-types";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./field.module.scss";
const Field = props => {
  const {
    children,
    id,
    label,
    optional,
    minWidth
  } = props;
  const classes = mergeClasses(defaultClasses, props.classes);
  const optionalSymbol = optional ? /*#__PURE__*/React.createElement("span", {
    className: classes.optional
  }, "Optional") : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(minWidth && classes.root, " ").concat(props.className)
  }, label ? /*#__PURE__*/React.createElement("label", {
    className: classes.label,
    htmlFor: id
  }, label, optionalSymbol) : null, children);
};
Field.propTypes = {
  children: node,
  className: string,
  classes: shape({
    label: string,
    root: string
  }),
  id: string,
  label: node,
  optional: bool
};
export default Field;